import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../../services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class NotAuthGuard  {
  private _user = inject(UserService);
  private _router = inject(Router);


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._user.auth$.pipe(
      map((auth) => {
        if (auth) {
          this._router.navigateByUrl('/');
        }
        return auth ? false : true;
      })
    );
  }
}
